import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-top">
        <div className="container">
          <div className="header-top-content">
            <div className="header-actions">
              <button 
                onClick={() => setShowLoginModal(true)} 
                className="header-link login-btn"
              >
                Login
              </button>
              <Link to="/membership" className="header-link">Become a member</Link>
              <div className="social-links">
                <a href="https://www.facebook.com/ebta.network" target="_blank" rel="noopener noreferrer" className="social-link">f</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="header-main">
        <div className="container">
          <div className="header-content">
            <div className="logo">
              <Link to="/">
                <img src="/images/logo-ebta.png" alt="EBTA" className="logo-img" />
              </Link>
            </div>

            <button
              className={`hamburger-menu ${mobileMenuOpen ? 'active' : ''}`}
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>

            <nav className={`main-nav ${mobileMenuOpen ? 'mobile-open' : ''}`}>
              <Link to="/" className="nav-link" onClick={closeMobileMenu}>Home</Link>
              <Link to="/about" className="nav-link" onClick={closeMobileMenu}>Who we are</Link>
              <div className="nav-dropdown">
                <span className="nav-link">What we do</span>
                <div className="dropdown-content">
                  <div className="nav-dropdown nested-dropdown">
                    <Link to="/activities" className="nav-link" onClick={closeMobileMenu}>Activities</Link>
                    <div className="dropdown-content">
                      <Link to="/conferences" onClick={closeMobileMenu}>Conferences</Link>
                      <Link to="/meet-and-learn" onClick={closeMobileMenu}>Meet&Learn</Link>
                      <Link to="/summercamp" onClick={closeMobileMenu}>Summer Camp</Link>
                      <Link to="/awards" onClick={closeMobileMenu}>Awards</Link>
                      <Link to="/research/grant" onClick={closeMobileMenu}>EBTA Research Grant</Link>
                    </div>
                  </div>
                  <Link to="/task-groups" onClick={closeMobileMenu}>Task Groups</Link>
                  <Link to="/research" onClick={closeMobileMenu}>Research</Link>
                  <Link to="/sf-research" onClick={closeMobileMenu}>SFA PubList by EBTA</Link>
                </div>
              </div>
              <Link to="/contact" className="nav-link" onClick={closeMobileMenu}>Contact</Link>
              <Link to="/conferences" className="nav-link conference-2026" onClick={closeMobileMenu} style={{
                background: 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
                color: 'white',
                padding: '0.5rem 1rem',
                borderRadius: '6px',
                fontWeight: '600',
                marginLeft: '1rem'
              }}>Conference 2026</Link>
            </nav>
          </div>
        </div>
      </div>

      {/* Login Modal */}
      {showLoginModal && (
        <div className="modal-overlay" onClick={() => setShowLoginModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button 
              className="modal-close" 
              onClick={() => setShowLoginModal(false)}
            >
              ×
            </button>
            <iframe 
              src="https://ebta.outseta.com/auth?widgetMode=login#o-anonymous"
              width="100%"
              height="500"
              frameBorder="0"
              title="EBTA Login Form"
              className="login-form"
            ></iframe>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
